import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import mirror_deghost_svg from '../../../assets/img/SVG_icons/Top/advanced_operation/mirror_deghost.svg';
import { img } from '@phi/components';
import { deghostify_selected_bodies } from '@frontend/scene';
import MirrorDeghostTooltip from './MirrorDeghostTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const MirrorDeghostIcon = mirror_deghost_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Materialise mirrored objects';
        },

        disabled() {
            return !this.state.loaded
                || this.state.editing_reference_partstudio
                || this.state.editing_reference_sketches
                || this.state.editing_reference_stl
                || !this.state.mirror_plane_selected
                || this.state.selected_faces_count === 0;
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                deghostify_selected_bodies();
        },
    },

    render() {
        return h(BarButton, {
            id: 'mirror-deghost-button',
            onClick: this.onClick,
            active: false,
            selected: this.state.tut_stage === 9,
            tippy: 'left',
            disabled: this.disabled,
            help: 'deghostify-mirror',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(mirror_deghost_svg, this.alt),
            tooltip: MirrorDeghostTooltip,
        });
    },
});
